// material
import { GlobalStyles as GlobalThemeStyles } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import palette from './learnerPalette';
import { styleConfigs } from '../components/resources/styleConfigs';

// ----------------------------------------------------------------------

export default function GlobalStyles(): JSX.Element {
  const theme = useTheme();

  return (
    <GlobalThemeStyles
      styles={{
        '*': {
          margin: 0,
          padding: 0,
          boxSizing: 'border-box',
        },
        html: {
          width: '100%',
          height: '100%',
          WebkitOverflowScrolling: 'touch',
        },
        body: {
          width: '100%',
          height: '100%',
        },
        '#root': {
          width: '100%',
          height: '100%',
        },
        input: {
          '&[type=number]': {
            MozAppearance: 'textfield',
            '&::-webkit-outer-spin-button': {
              margin: 0,
              WebkitAppearance: 'none',
            },
            '&::-webkit-inner-spin-button': {
              margin: 0,
              WebkitAppearance: 'none',
            },
          },
        },
        textarea: {
          '&::-webkit-input-placeholder': {
            color: theme.palette.text.disabled,
          },
          '&::-moz-placeholder': {
            opacity: 1,
            color: theme.palette.text.disabled,
          },
          '&:-ms-input-placeholder': {
            color: theme.palette.text.disabled,
          },
          '&::placeholder': {
            color: theme.palette.text.disabled,
          },
        },

        img: { display: 'block', maxWidth: '100%' },

        // Lazy Load Img
        '.blur-up': {
          WebkitFilter: 'blur(5px)',
          filter: 'blur(5px)',
          transition: 'filter 400ms, -webkit-filter 400ms',
        },
        '.blur-up.lazyloaded ': {
          WebkitFilter: 'blur(0)',
          filter: 'blur(0)',
        },
        '.MuiModal-root': {
          '.MuiPaper-root': {
            'ul li.Mui-selected.Mui-focusVisible': {
              backgroundColor: `${palette.light.background.listSelected} !important`,
            },
          },
        },
        '.MuiAutocomplete-listbox': {
          '&::-webkit-scrollbar': {
            width: `${styleConfigs.marginPadding.custom6}px`,
          },
          '&::-webkit-scrollbar-track': {
            background: 'transparent',
          },
          '&::-webkit-scrollbar-thumb': {
            background: palette.light.background.cadetGrey,
            borderRadius: `${styleConfigs.marginPadding.custom3}px`,
          },
          '&::-webkit-scrollbar-thumb:hover': {
            background: palette.light.background.mistBlue,
          },
        },
      }}
    />
  );
}
